import React, { useState } from 'react';


const ContactMain = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
 
 const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true);

  try {
    const response = await fetch('/send-mail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      }),
    });

    const result = await response.json();

    if (result.success) {
      alert('Thank you! Your inquiry has been submitted successfully.');

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });
    } else {
      alert(result.error || 'Failed to send email');
    }
  } catch (error) {
    console.error(error);
    alert('Something went wrong. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <React.Fragment>
      {/* Contact One Start */}
      <section className="contact-one">
        <div className="container">
          <div className="contact-one__inner">
            <h3 className="contact-one__title">
              Write here below?
            </h3>

            <p className="contact-one__text">
              From corporate gatherings to exclusive experiences, our team is
              ready to make your event exceptional.
            </p>

            <form
              className="contact-form-validated contact-one__form"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-12">
                  <div className="contact-one__input-box">
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-12">
                  <div className="contact-one__input-box text-message-box">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="contact-one__btn-box">
                    <button
                      type="submit"
                      className="thm-btn contact-one__btn"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Submit Now'}
                      <span className="icon-arrow-right"></span>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <div className="result"></div>
          </div>
        </div>
      </section>
      {/* Contact One End */}

      {/* Contact Two Start */}
      <style>{`
        .contact-two .offices-row > [class*="col-"] {
          display: flex;
        }
        .contact-two .offices-row .contact-two__single {
          width: 100%;
          height: 100%;
        }
        .contact-two .branch-copy {
          margin: 0;
        }
        .contact-two .branch-copy + .branch-copy {
          margin-top: 12px;
        }
        .contact-two .address-split {
          margin-top: 16px;
          padding-top: 16px;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
        }
        .contact-two .branch-tag {
          display: block;
          margin-bottom: 2px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.14em;
          background: linear-gradient(90deg, #B20D5D 0%, #4A0AB4 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        @media (max-width: 991px) {
          .contact-two .offices-row > [class*="col-"] {
            margin-bottom: 28px;
          }
          .contact-two .offices-row .contact-two__single {
            padding: 48px 32px 52px;
            margin-bottom: 0;
          }
          .contact-two .address-split {
            margin-top: 24px;
            padding-top: 24px;
          }
        }
      `}</style>
      <section className="contact-two">
        <div className="container">
          <div className="row offices-row">
            <div className="col-lg-3 col-md-6">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-pin"></span>
                </div>
                <h3 className="contact-two__title">UAE BRANCH</h3>
                <p className="contact-two__text branch-copy">
                  Globetrotting Nomads FZC LLC
                  <br />
                  CWS-1V-001696
                  <br />
                  26th Floor, Amber Gem Tower, Ajman
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-pin"></span>
                </div>
                <h3 className="contact-two__title">INDIA BRANCH</h3>
                <p className="contact-two__text branch-copy">
                  O-303, Roshina Enclave,
                  <br />
                  Margao, Goa. 403601
                </p>
                <p className="contact-two__text branch-copy address-split">
                  304, City Center,
                  <br />
                  Patto, Panjim, Goa. 403001
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-paper-plan"></span>
                </div>
                <h3 className="contact-two__title">E-mail</h3>
                <p className="contact-two__text branch-copy">
                  <a href="mailto:sheldon@gtnomads.com">sheldon@gtnomads.com</a>
                  <br />
                  <a href="mailto:andre@gtnomads.com">andre@gtnomads.com</a>
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="contact-two__single">
                <div className="contact-two__icon">
                  <span className="icon-call"></span>
                </div>
                <h3 className="contact-two__title">Contact</h3>
                <p className="contact-two__text branch-copy">
                  <span className="branch-tag">UAE</span>
                  <a href="tel:+971569870856">+971 56 987 0856</a>
                </p>
                <p className="contact-two__text branch-copy">
                  <span className="branch-tag">INDIA</span>
                  <a href="tel:+919822980756">+91 98229 80756</a>
                  <br />
                  <a href="tel:+919822959761">+91 98229 59761</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Two End */}
    </React.Fragment>
  );
};

export default ContactMain;